import { FormattedMessage } from 'react-intl';

export const DateRangeDisplay = ({
  from,
  to,
  prefix = 'Updated',
}: {
  from?: string;
  to?: string;
  prefix?: string;
}): JSX.Element => {
  if (from !== undefined && to !== undefined) {
    return (
      <div className="py-1 px-2 bg-blue-500 text-sm rounded-sm text-white">
        <FormattedMessage
          id="coverage.details.intervalFromTo"
          values={{ from, to, prefix }}
        />
      </div>
    );
  }
  if (from !== undefined) {
    return (
      <div className="py-1 px-2 bg-blue-500 text-sm rounded-sm text-white">
        <FormattedMessage
          id="coverage.details.intervalFrom"
          values={{ from, prefix }}
        />
      </div>
    );
  }
  if (to !== undefined) {
    return (
      <div className="py-1 px-2 bg-blue-500 text-sm rounded-sm text-white">
        <FormattedMessage
          id="coverage.details.intervalTo"
          values={{ to, prefix }}
        />
      </div>
    );
  }

  return <></>;
};
